import { z } from 'zod';

import { ChatUiMoneySchema } from '../../shared/schema/money_schema.js';
import { chatUiBase } from '../../shared/schema/base.js';

/**
 * Card de mudança de preço (`rental_price_change`) — emitido pelo agente quando
 * a validação de disponibilidade detecta que o total do veículo escolhido mudou
 * desde a busca. Mostra preço antigo → novo + dois botões renderizados pelo
 * agente: "Continuar mesmo assim" e "Cancelar".
 *
 * `offerId` é o veículo escolhido: presente ⇒ "Continuar mesmo assim" dispara um
 * `rental-select` estruturado (o MESMO canal do botão "Alugar"), reusando o id +
 * o novo preço como baseline — o agente revalida pelo id e finaliza sem o LLM
 * reinterpretar a posição. Ausente (cards históricos) ⇒ cai no caminho de texto.
 *
 * `challengeId` é opcional: presente (e sem `offerId`) ⇒ "Continuar" resolve via
 * canal `interaction` (challenge estruturado); ausente ⇒ `reply` em texto livre.
 */
const ChatUiRentalPriceChangeSchema = z.object({
  offerId: z.string().min(1).optional(),
  vehicleName: z.string().optional(),
  previousPrice: ChatUiMoneySchema,
  newPrice: ChatUiMoneySchema,
  challengeId: z.string().min(1).optional(),
});
export type ChatUiRentalPriceChange = z.infer<typeof ChatUiRentalPriceChangeSchema>;

/** Membro `rental_price_change` do `ChatUiSchema` (discriminatedUnion). */
export const RentalPriceChangeBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('rental_price_change'),
    priceChange: ChatUiRentalPriceChangeSchema,
  })
  .strict();
